<template>
  <span>
    <human-duration :class="{'text--muted': printTimeInt===0}" :seconds="timeToShow" :id="uniqueId"></human-duration>
    <b-tooltip v-if="printTimeInt > 0" :target="uniqueId">
      <div class="text-left">
        <human-duration class="text--muted-light" :seconds="estimatedTimeInt"></human-duration> - {{$t('printTime.estimated')}}
        <br />
        <human-duration :seconds="printTimeInt"></human-duration> - {{$t('printTime.actual')}}
      </div>
    </b-tooltip>
    <b-tooltip v-else :target="uniqueId">{{$t('printTime.estimatedTime')}}</b-tooltip>
  </span>
</template>

<script>
  import HumanDuration from "./HumanDuration";
  export default {
    name: 'print-time',
    components: {HumanDuration},
    props: {
      printTime: {
        default: 0
      },
      estimatedTime: {
        required: true
      },
      objectId: {
        type: [Number, String]
      }
    },
    data() {
      return {
        uniqueId: null
      }
    },
    created() {
      const uniqueKey = this.objectId ? this.objectId : `f${(~~(Math.random()*1e8)).toString(8)}`;
      this.uniqueId = 'pt-' + uniqueKey;
    },
    computed: {
      printTimeInt() {
        const val = parseInt(this.printTime);
        return isNaN(val) ? 0 : val;
      },
      estimatedTimeInt() {
        const val = parseInt(this.estimatedTime);
        return isNaN(val) ? 0 : val;
      },
      timeToShow() {
        return this.printTimeInt > 0 ? this.printTimeInt : this.estimatedTimeInt;
      }
    }
  }
</script>
